module.exports = __webpack_public_path__ + "static/media/man.4bb5a34d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/man.png
// module id = 81
// module chunks = 0